export const formatCurrency = (amount) => {
  if (amount == null || isNaN(amount)) return '—';
  return `₹${Number(amount).toLocaleString('en-IN')}`;
};
